export default "__VITE_ASSET__B9pfHh5k__"